import { render } from "./Toplist.vue?vue&type=template&id=04073b30"
import script from "./Toplist.vue?vue&type=script&lang=js"
export * from "./Toplist.vue?vue&type=script&lang=js"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__